import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useDataProvider } from "../hooks/data/DataProvider";

import SimpleIDE from "../ide/SimpleIDE/SimpleIDE";
import AdvancedIDE from "../ide/AdvancedIDE";


const IDE = () => {
    const { labId, projectId } = useParams();

    const {
        getProject,
        fetchProject,
        loading,
        error
    } = useDataProvider();

    const [project, setProject] = useState(null);
    

    /*
     * --------------------------------------------------------
     * LOAD PROJECT
     * --------------------------------------------------------
     */

    useEffect(() => {
        let cancelled = false;

        const loadProject = async () => {
            if (!projectId) {
                return;
            }

            /*
             * First check DataProvider.
             */
            const existingProject = getProject(projectId);

            /*
             * If it already contains IDE configuration,
             * use it immediately.
             */
            if (
                existingProject &&
                existingProject.ide_type
            ) {
                if (!cancelled) {
                    setProject(existingProject);
                }
                return;
            }

            /*
             * Otherwise fetch the complete project.
             */
            try {
                const result = await fetchProject(projectId);

                if (!cancelled) {
                    /*
                     * fetchProject may return the project,
                     * or DataProvider may only update its store.
                     */
                    const fetchedProject =
                        result ||
                        getProject(projectId);

                    if (fetchedProject) {
                        setProject(fetchedProject);
                    }
                }
            } catch (err) {
                if (!cancelled) {
                    console.error(
                        "Failed to load project:",
                        err
                    );
                }
            }
        };

        loadProject();

        return () => {
            cancelled = true;
        };

    }, [projectId, getProject, fetchProject]);


    /*
     * --------------------------------------------------------
     * PROJECT ID
     * --------------------------------------------------------
     */

    if (!projectId) {
        return (
            <div className="ide-error">
                <div className="alert alert-danger">
                    Project ID is missing.
                </div>
            </div>
        );
    }


    /*
     * --------------------------------------------------------
     * LOADING
     * --------------------------------------------------------
     */

    if (!project) {
        return (
            <div className="ide-loading">
                <div className="loader-spinner" />
                <p>Loading project...</p>
            </div>
        );
    }


    /*
     * --------------------------------------------------------
     * ERROR
     * --------------------------------------------------------
     */

    if (error && !project) {
        return (
            <div className="ide-error">
                <div className="alert alert-danger">
                    {error}
                </div>
            </div>
        );
    }


    /*
     * --------------------------------------------------------
     * WAIT FOR IDE CONFIGURATION
     * --------------------------------------------------------
     *
     * Do NOT immediately display:
     *
     *     Unknown IDE type: not specified
     *
     * because the project may have loaded before
     * ide_type was populated.
     */

    if (!project.ide_type) {
        return (
            <div className="ide-loading">
                <div className="loader-spinner" />
                <p>Loading IDE configuration...</p>
            </div>
        );
    }


    /*
     * --------------------------------------------------------
     * PROJECT CONFIGURATION
     * --------------------------------------------------------
     */

    const ideType = String(project.ide_type).toLowerCase().trim();
    const level = String(project.level || "").toLowerCase().trim();

    //console.log(`IDE ideType=${ideType} level=${level}`);
    /*
     * --------------------------------------------------------
     * SIMPLE IDE
     * --------------------------------------------------------
     */

    if (ideType === "simple") {

        if (level === "beginner") {
            console.log("IDE xxxxx  project ", project.id)
            return (
                <SimpleIDE
                    projectId={projectId}
                    mode="graphical"
                    project={project}
                />
            );
        }

        if (level === "experienced") {
            return (
                <SimpleIDE
                    projectId={projectId}
                    mode="text"
                    project={project}
                />
            );
        }

        return (
            <div className="ide-error">
                <div className="alert alert-danger">
                    Invalid Simple IDE level:{" "}
                    {project.level || "not specified"}
                </div>
            </div>
        );
    }


    /*
     * --------------------------------------------------------
     * ADVANCED IDE
     * --------------------------------------------------------
     */

    if (ideType === "advanced") {
        return (
            <AdvancedIDE
                labId={labId}
                projectId={projectId}
                project={project}
            />
        );
    }


    /*
     * --------------------------------------------------------
     * UNKNOWN IDE TYPE
     * --------------------------------------------------------
     */

    return (
        <div className="ide-error">
            <div className="alert alert-danger">
                Unknown IDE type: {project.ide_type}
            </div>
        </div>
    );
};


export default IDE;